import { ConfigDataType } from './config.interface';

export const DEFAULT_CONFIG: ConfigDataType = {
  env: 'development',
  port: 2005,
  selfHost: "http://analytics23.sepl.local",
  logLevel: 'info',
  maxPayloadSize: '1000mb',
  responseTimeOut: 600,
  staticFilesFolder: 'files',
  database: {
    type: 'mysql',
    host: '206.189.138.212',
    port: 3306,
    username: 'sa_dev_user',
    password: 'Schemax@23',
    dbName: 'parikshit_india',
    poolLimit: 20,
    charset: 'utf8mb4_unicode_ci'
  },
  rateLimiting: {
    ttl: 60,
    limit: 10,
    maxLoginAttempts: 3
  },
  appSepcific: {
    palletRollCapacity: 20
  },
  jwtConfig: {
    jwtSecret: 'rebats',
    jwtExpiryTime: '300s',   //seconds(15 mins)     
    refreshSecret: 'rebats_refresh',
    refreshExpiryTime: '7d',//days(one week)
    jwtByCookieOrHeader: 'cookie'
  },
  dbNames: {
    boip: "",
    ums: "",
  }
};
